export default __webpack_public_path__ + "static/media/osa.4b9ff679.svg";